"use client";

import { Loader2 } from "lucide-react";
import { useTranslations } from "next-intl";

import { useOnlineStatus } from "@/app/hooks/useOnlineStatus";
import { Button } from "@/components/ui/button";

interface AppleSignInButtonProps {
  onClick: () => void;
  isLoading: boolean;
  disabled?: boolean;
  className?: string;
}

export function AppleSignInButton({
  onClick,
  isLoading,
  disabled,
  className,
}: AppleSignInButtonProps) {
  const t = useTranslations("auth");
  const { isOffline } = useOnlineStatus();

  return (
    <Button
      variant="outline"
      className={`w-full justify-center gap-2 h-11 ${className || ""}`}
      onClick={onClick}
      disabled={disabled || isOffline}
    >
      {isLoading ? (
        <Loader2 className="w-5 h-5 animate-spin" />
      ) : (
        <svg className="w-7 h-7" viewBox="0 0 20 24" fill="currentColor" aria-hidden="true">
          <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
        </svg>
      )}
      {t("signInWithApple")}
    </Button>
  );
}
